import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function CollectionCard({ collection }) {
  return (
    <Link
      to={`/collections/${collection.handle}`}
      className="group relative block overflow-hidden bg-cream"
      data-testid="featured-collection-card"
    >
      <div className="aspect-[3/4] overflow-hidden">
        <img
          src={collection.image}
          alt={collection.title}
          loading="lazy"
          className="h-full w-full object-cover object-center transition-transform duration-1000 ease-out group-hover:scale-110"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 text-ivory">
        <h3 className="font-serif text-2xl sm:text-3xl font-light">{collection.title}</h3>
        <span className="mt-2 inline-flex items-center gap-2 text-luxe text-[11px] font-medium text-ivory/90 transition-all duration-300 group-hover:gap-3 group-hover:text-gold">
          Shop Collection
          <ArrowRight size={14} />
        </span>
      </div>
    </Link>
  );
}
